import {Reward} from "@/store/api/rewardApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface RewardState {
    rewardList: Reward[];
}

const initialState: RewardState = {
    rewardList: [],
}

const rewardSlice = createSlice({
    name: "reward",
    initialState,
    reducers: {
        setRewardList: (state, action: PayloadAction<Reward[]>) => {
            state.rewardList = action.payload;
        },
        clearRewardList: (state) => {
            state.rewardList = []
        }
    }

})

export const {setRewardList, clearRewardList} = rewardSlice.actions;
export default rewardSlice.reducer;